import LocationSelects from './location-selects';
import MapWrapper from '../../../map-wrapper';

export default function MapSection() {
    return(
        <div className="stores"> 
            <div className="stores__content">
                <div className="location-filter">
                    <div className="location-filter__title">Карта расположения магазинов</div>
                    <LocationSelects/>
                </div>
                <div className="stores-map">
                    <MapWrapper className="partners-map" />
                </div>
            </div>
        </div>
    );
}